import { catalog } from '../core/catalog.js';
import { spotify } from '../core/spotify.js';
import { toggleSpotifyLink } from '../ui/spotify.js';
import { catalogStore } from '../core/catalog-store.js';
import { epg } from '../core/epg.js';
import { profiles } from '../core/profiles.js';
import { account } from '../core/account.js';
import { openTwoFactor } from '../ui/twofa.js';
import { termsRecord } from '../core/terms.js';
import { viewers, avatarColor, avatarInitial } from '../core/viewers.js';
import { settings, storage } from '../core/storage.js';
import { device } from '../core/device.js';
import { devMode } from '../core/dev-mode.js';
import { buildConfigExport, configFileName } from '../core/config-export.js';
import { shareContent } from '../core/share.js';
import { i18n, t } from '../core/i18n.js';
import { addPasswordToggles } from '../core/pwtoggle.js';
import { notify } from '../core/notify.js';
import { transcodeAvailable } from '../core/transcode.js';
import { coach } from '../core/coach.js';
import { playSound } from '../core/ui-sounds.js';
import { factoryReset } from '../core/factory-reset.js';
import { openCredits } from './credits.js';
import { openLicensesAdmin } from './licenses-admin.js';
import { openUsageAdmin } from './usage-admin.js';
import { openCatalogReview } from './catalog-review.js';
import { openCatalogStatus } from './catalog-status.js';
import { firstScreen } from './start.js';
import { openPaymentsAdmin } from './payments-admin.js';
import { inviteWeb } from '../core/invite-web.js';
import { openAccessRequests, pendingRequestCount } from './access-requests.js';
import { db } from '../core/db.js';
import { escapeHtml, formatDate, formatBytes, debounce } from '../core/utils.js';
import { pageHead } from '../ui/render.js';
import { openUsersAdmin } from './admin.js';
import { openDevices } from './devices.js';
import { openSkinPicker } from './skins.js';
import { skinById } from '../core/skins.js';
import { shellById } from '../core/shells.js';
import { openShellPicker } from './shells.js';
import { SUB_LANGS } from '../core/player-ui.js';
import { providers } from '../core/providers.js';
import { offline } from '../core/offline.js';
import { openMenu } from '../ui/menu.js';
import { panelHtml, modalHtml, listHtml, summaryHtml, detailHtml, fmtNum } from './sources-ui.js';
import { providerType } from '../core/clients.js';
import { presetOf } from '../core/presets.js';
import { openSupport } from './support.js';
import { openHeroAdmin } from './hero-admin.js';
import { openParentalCategories } from './parental-cats.js';
import { support } from '../core/support.js';
import { openReport } from './report.js';
import { openReportsAdmin } from './reports-admin.js';
import { openSurveyAdmin } from './survey-admin.js';
import { openDocsAdmin } from './docs-admin.js';
import { startIntro } from '../core/intro.js';

function item({ icon, title, sub, value, action, toggle, danger, href }) {
    const tag = href ? 'a' : 'button';
    return `<${tag} class="setting ${danger ? 'is-danger' : ''}" ${href ? `href="#" data-href="${href}"` : `type="button" data-setting="${action}"`}>
        ${icon ? `<span class="mi">${icon}</span>` : ''}
        <span class="setting-body"><span class="setting-title">${escapeHtml(title)}</span>${sub ? `<span class="setting-sub">${escapeHtml(sub)}</span>` : ''}</span>
        ${toggle != null ? `<span class="switch ${toggle ? 'is-on' : ''}" aria-hidden="true"></span>` : value != null ? `<span class="setting-value">${escapeHtml(value)}</span><span class="mi">chevron_right</span>` : ''}
    </${tag}>`;
}

const navFadeValue = (s) => (Number.isFinite(Number(s.navFade)) ? Math.max(0, Math.min(100, Math.round(Number(s.navFade)))) : 33);
/** Fila con deslizador (el resto de ajustes son botones): transparencia del menú sobre la cabecera de Inicio. */
function navFadeRow(s) {
    const v = navFadeValue(s);
    return `<div class="setting setting-slider"><span class="mi">gradient</span><span class="setting-body"><span class="setting-title">${escapeHtml(t('settings.navFade'))}</span><span class="setting-sub">${escapeHtml(t('settings.navFadeSub'))}</span><input type="range" min="0" max="100" step="5" value="${v}" data-nav-fade aria-label="${escapeHtml(t('settings.navFade'))}"/></span><span class="setting-value" data-nav-fade-val>${v} %</span></div>`;
}

const NEXT_OFFER = [0, 60, 120, 180, 240, 300];

function nextOfferLabel(sec) {
    const n = Number(sec);
    return n > 0 ? t('settings.nextOfferMin', { n: Math.round(n / 60) }) : n === 0 ? t('settings.nextOfferOff') : t('settings.nextOfferMin', { n: 3 });
}

function transcodeLabel(mode) {
    return mode === 'always' ? t('settings.transcodeAlways') : mode === 'never' ? t('settings.transcodeNever') : t('common.auto');
}

/* Los ajustes se reparten en pestañas. Cada tarjeta lleva el atributo data-tab según su título; las que no se conocen van a «Más». */
const SETTINGS_TABS = [['account', 'settings.tabAccount'], ['sources', 'settings.tabSources'], ['appearance', 'settings.tabAppearance'], ['playback', 'settings.tabPlayback'], ['devices', 'settings.tabDevices'], ['more', 'settings.tabMore']];
const TAB_OF_TITLE = () => ({
    [t('settings.viewers')]: 'account', [t('settings.filoteca')]: 'account', [t('settings.parental')]: 'account',
    [t('settings.tmdbGroup')]: 'sources', [t('settings.tmdbGroupLocal')]: 'sources', [t('settings.data')]: 'sources', [t('settings.network')]: 'sources',
    [t('settings.appearance')]: 'appearance',
    [t('settings.playback')]: 'playback', [t('rec.title')]: 'playback',
    [t('connect.title')]: 'devices',
    [t('settings.diagnostics')]: 'more', [t('settings.about')]: 'more'
});
const tabFor = (title) => TAB_OF_TITLE()[title] || 'more';
/** Cuándo se aceptaron los términos en este aparato (fila de Ajustes). */
function termsSub() {
    const r = termsRecord();
    return r ? t('terms.gate.acceptedOn', { date: new Date(r.at).toLocaleDateString(i18n.lang), version: r.version }) : t('terms.gate.notAccepted');
}

const TAB_KEY = 'settingsTab';
let activeTab = '';

/** Deja elegida la pestaña de Ajustes que se verá al abrirla (p. ej. «Fuentes» desde el botón «Añadir proveedor» del Inicio). */
export function preferSettingsTab(id) {
    activeTab = id;
    tvOpenNext = true;
    try { localStorage.setItem('iptv:' + TAB_KEY, id); } catch (e) { /* sin almacenamiento */ }
}
let accessPending = 0; // solicitudes de acceso a tus proveedores que esperan respuesta (web con cuenta)
try { activeTab = localStorage.getItem('iptv:' + TAB_KEY) || ''; } catch (e) { /* sin almacenamiento */ }

function group(title, items) {
    return `<div class="settings-group" data-tab="${tabFor(title)}"><div class="settings-group-title">${escapeHtml(title)}</div>${items.join('')}</div>`;
}

/* Modo tele: los Ajustes se ven como los del Fire TV. Primero una rejilla de mosaicos (uno por pestaña) a pantalla completa y,
   al entrar en uno, tres columnas: el título a la izquierda, la lista en el centro y el detalle de lo enfocado a la derecha. */
const TV_TAB_ICONS = { account: 'person', sources: 'video_library', appearance: 'palette', playback: 'play_circle', devices: 'devices', more: 'more_horiz' };
const tvLayout = () => document.documentElement.classList.contains('fire-layout'); // la tele, o quien lo haya activado en Ajustes
const tvMode = () => device.isTV || document.documentElement.classList.contains('mode-tv'); // el mando mueve el foco: solo en la tele
let tvSourcesList = () => ''; // la lista de fuentes que va en la columna derecha de «Fuentes» (la pone mount())
let tvOpen = false; // en modo tele: ¿se está dentro de un mosaico (tres columnas) o en la rejilla?
let tvOpenNext = false; // preferSettingsTab() pide entrar directo en una pestaña

/** El detalle (columna derecha) de lo que tiene el foco: título, explicación completa y valor actual. */
function tvDetailHtml(body, target) {
    const el = target || body.querySelector('.is-focused') || (body.contains(document.activeElement) ? document.activeElement : null);
    const row = el && el.closest ? el.closest('.setting') : null;
    if (!row) {
        const grp = el && el.closest ? el.closest('.settings-group') : null;
        const title = grp ? (grp.querySelector('.settings-group-title') || {}).textContent || '' : '';
        let text = '';
        if (el) { const c = el.cloneNode(true); c.querySelectorAll('.mi').forEach((n) => n.remove()); text = String(c.textContent || '').replace(/\s+/g, ' ').trim().slice(0, 240); }
        return `<div class="tvs-d-title">${escapeHtml(title || text)}</div>${title && text ? `<div class="tvs-d-sub">${escapeHtml(text)}</div>` : ''}`;
    }
    const title = (row.querySelector('.setting-title') || {}).textContent || '';
    const sub = (row.querySelector('.setting-sub') || {}).textContent || '';
    const sw = row.querySelector('.switch');
    const value = sw ? t(sw.classList.contains('is-on') ? 'common.on' : 'common.off') : (row.querySelector('.setting-value') || {}).textContent || '';
    const icon = (row.querySelector('.mi') || {}).textContent || '';
    return `${icon ? `<span class="mi tvs-d-icon">${escapeHtml(icon)}</span>` : ''}<div class="tvs-d-title">${escapeHtml(title)}</div>${value ? `<div class="tvs-d-value">${escapeHtml(value)}</div>` : ''}${sub ? `<div class="tvs-d-sub">${escapeHtml(sub)}</div>` : ''}<div class="tvs-d-hint">${escapeHtml(t(sw ? 'settings.tvHintToggle' : 'settings.tvHintOpen'))}</div>`;
}

function applyTvSettings(body, tabs) {
    body.querySelectorAll(':scope > .tvs-grid, :scope > .tvs-left, :scope > .tvs-right, :scope > .settings-tabs').forEach((n) => n.remove());
    const groups = body.querySelectorAll(':scope > [data-tab]');
    body.classList.add('tvs');
    const open = tvOpen && tabs.some((x) => x[0] === activeTab);
    body.classList.toggle('tvs-detail', open);
    if (!open) {
        groups.forEach((g) => g.classList.add('is-off-tab'));
        body.insertAdjacentHTML('afterbegin', `<div class="tvs-grid">${tabs.map((x) => `<button type="button" class="tvs-tile ${x[0] === activeTab ? 'is-last' : ''}" data-focusable ${x[0] === activeTab ? 'data-nav-default' : ''} data-settings-tab="${x[0]}"><span class="mi">${TV_TAB_ICONS[x[0]] || 'settings'}</span><span class="tvs-tile-label">${escapeHtml(t(x[1]))}</span></button>`).join('')}</div>`);
        return;
    }
    groups.forEach((g) => g.classList.toggle('is-off-tab', g.getAttribute('data-tab') !== activeTab));
    const label = (tabs.find((x) => x[0] === activeTab) || [])[1];
    const listed = activeTab === 'sources' ? tvSourcesList() : '';
    body.insertAdjacentHTML('afterbegin', `<div class="tvs-left"><span class="mi">${TV_TAB_ICONS[activeTab] || 'settings'}</span><div class="tvs-left-title">${escapeHtml(label ? t(label) : '')}</div><button type="button" class="tvs-back" data-focusable data-tvs-back><span class="mi">arrow_back</span>${escapeHtml(t('addsrc.back'))}</button></div><aside class="tvs-right ${listed ? 'is-list' : ''}" data-tvs-detail>${listed || tvDetailHtml(body)}</aside>`);
}

/** Pone la barra de pestañas y deja a la vista solo las tarjetas de la pestaña activa (las pestañas sin tarjetas no se enseñan). */
function applySettingsTabs(body) {
    const present = new Set(Array.from(body.querySelectorAll(':scope > [data-tab]')).map((g) => g.getAttribute('data-tab')));
    const tabs = SETTINGS_TABS.filter((x) => present.has(x[0]));
    if (!tabs.some((x) => x[0] === activeTab)) activeTab = tabs.length ? tabs[0][0] : '';
    if (tvLayout()) {
        if (tabs.length < 2) tvOpen = true; // un solo apartado: se entra directo
        applyTvSettings(body, tabs);
        return;
    }
    body.classList.remove('tvs', 'tvs-detail');
    body.querySelectorAll(':scope > [data-tab]').forEach((g) => g.classList.toggle('is-off-tab', g.getAttribute('data-tab') !== activeTab));
    const old = body.querySelector(':scope > .settings-tabs');
    if (old) old.remove();
    if (tabs.length < 2) return;
    body.insertAdjacentHTML('afterbegin', `<div class="chips settings-tabs" role="tablist" data-nav-row data-nav-reach>${tabs.map((x) => `<button type="button" role="tab" class="chip ${x[0] === activeTab ? 'is-active' : ''}" aria-selected="${x[0] === activeTab}" data-settings-tab="${x[0]}">${escapeHtml(t(x[1]))}</button>`).join('')}</div>`);
}

const hostOf = (p) => {
    if (p.type === 'local') return '';
    if (p.type === 'dropbox' || p.type === 'onedrive') return p.username || '';
    const raw = String(p.type === 'm3u' ? p.m3uUrl || '' : p.host || '').replace(/^(https?|smb):\/\//, '');
    // SMB: «nas/Películas/Cine» entero; el resto, solo hasta la primera barra o interrogante.
    return p.type === 'smb' ? raw : raw.replace(/[/?].*$/, '');
};

/** Texto de caducidad: «Caduca el 28 may 2027 · quedan 241 días», «Caducó el… · hace 5 días»… */
function expiryText(sub, library) {
    if (sub.state === 'none') return '';
    if (!sub.expiresAt) return sub.state === 'disabled' ? '' : t(library ? 'sub.own' : 'sub.never');
    const date = formatDate(sub.expiresAt, i18n.lang);
    if (sub.state === 'expired' && sub.expiresAt <= Date.now()) {
        const ago = -sub.daysLeft;
        return t('sub.expiredOn', { date }) + ' · ' + (ago <= 0 ? t('sub.today') : ago === 1 ? t('sub.yesterday') : t('sub.daysAgo', { n: ago }));
    }
    return t('sub.expiresOn', { date }) + ' · ' + (sub.daysLeft === 0 ? t('sub.today') : sub.daysLeft === 1 ? t('sub.dayLeft') : t('sub.daysLeft', { n: sub.daysLeft }));
}

/** Etiqueta de estado de un proveedor: el fallo de la última comprobación manda sobre lo guardado. */
function stateOf(profile, st) {
    if (st.error === 'auth') return { key: 'rejected', label: t('sub.state.rejected') };
    if (st.sub.state === 'none') {
        if (profile.type === 'm3u') return presetOf(profile) ? { key: 'active', label: t('sub.state.free') } : { key: 'list', label: t('sub.state.list') };
        return st.error ? { key: 'offline', label: t('sub.state.offline') } : { key: 'unknown', label: t('sub.state.unknown') };
    }
    return { key: st.sub.state, label: t('sub.state.' + st.sub.state) + (st.sub.trial ? ' · ' + t('sub.trial') : '') };
}

const included = () => storage.get('includedProfiles', []) || [];

/** Qué aporta al catálogo un proveedor añadido: títulos nuevos y repetidos (que quedan de respaldo). */
/** «No se pudieron cargar las películas (se reintenta)»: el panel no contestó a alguna lista del catálogo. */
function partialLine(data) {
    if (!data || !data.partial || !data.partial.length) return '';
    const what = data.partial.map((k) => t(k === 'live' ? 'common.channels' : k === 'vod' ? 'common.movies' : 'common.series')).join(', ');
    return `<span class="provider-line is-warn"><span class="mi">report_problem</span>${escapeHtml(t('settings.providerPartial', { what }))}</span>`;
}

function contributionLine(p) {
    const src = catalog.sources.get(p.id);
    if (!src) return '';
    if (src.loading && !src.data) return `<span class="provider-line"><span class="mi">sync</span>${escapeHtml(t('settings.providerLoading'))}</span>`;
    if (src.error && !src.data) return `<span class="provider-line is-warn"><span class="mi">cloud_off</span>${escapeHtml(t('settings.providerLoadError'))}</span>`;
    const st = catalog.mergeStats[p.id];
    if (!st) return partialLine(src.data);
    const sum = (k) => st.live[k] + st.vod[k] + st.series[k];
    return `<span class="provider-line is-gain"><span class="mi">library_add</span>${escapeHtml(t('settings.providerAdds', { movies: st.vod.added, series: st.series.added, channels: st.live.added }))}</span>
        ${sum('merged') ? `<span class="provider-line"><span class="mi">backup</span>${escapeHtml(t('settings.providerBackup', { n: sum('merged') }))}</span>` : ''}${partialLine(src.data)}`;
}

/** Una tarjeta por proveedor con su tipo, estado, caducidad y conexiones. */
function providerCard(p, current) {
    const st = providers.get(p, { simulate: current ? catalog.simulate : '' });
    const state = stateOf(p, st);
    const sub = st.sub;
    const isIncluded = !current && included().indexOf(p.id) !== -1;
    const preset = presetOf(p);
    const lines = [];
    const expiry = expiryText(sub, providerType(p.type).group !== 'iptv');
    if (expiry) lines.push(`<span class="provider-line is-expiry"><span class="mi">event</span>${escapeHtml(expiry)}</span>`);
    if (sub.state !== 'none' && (sub.max || sub.active)) lines.push(`<span class="provider-line"><span class="mi">devices</span>${escapeHtml(t('sub.connections', { active: sub.active, max: sub.max || '∞' }))}</span>`);
    // Cuándo se actualizó por última vez su catálogo (en ámbar si lleva más de un día y la actualización diaria está activada).
    const at = catalogStore.updatedAt(p.id);
    if (at) {
        const old = settings.get('catalogAuto') !== false && Date.now() - at > 36 * 3600 * 1000;
        const when = new Date(at).toLocaleString(i18n.lang, { day: 'numeric', month: 'short', hour: '2-digit', minute: '2-digit' });
        lines.push(`<span class="provider-line ${old ? 'is-warn' : ''}"><span class="mi">update</span>${escapeHtml(t('settings.catalogAt', { date: when }))}</span>`);
    }
    if (st.error === 'network' && sub.state !== 'none') lines.push(`<span class="provider-line is-warn"><span class="mi">cloud_off</span>${escapeHtml(t('sub.lastKnown'))}</span>`);
    if (st.error === 'auth') lines.push(`<span class="provider-line is-warn"><span class="mi">key_off</span>${escapeHtml(t('sub.rejectedText'))}</span>`);
    if (sub.simulated) lines.push(`<span class="provider-line is-warn"><span class="mi">science</span>${escapeHtml(t('sub.simulated'))}</span>`);
    const active = current || isIncluded;
    return `<div class="provider-card is-${state.key} ${current ? 'is-current' : ''} ${active ? '' : 'is-off'}" data-provider="${escapeHtml(p.id)}">
        <span class="provider-icon"><span class="mi">${preset ? preset.icon : providerType(p.type).icon}</span></span>
        <div class="provider-body">
            <div class="provider-head">
                <span class="provider-name">${escapeHtml(p.name || (p.shared ? t('share.sharedName') : hostOf(p)))}</span>
                <span class="provider-state is-${state.key}">${escapeHtml(state.label)}</span>
                ${current ? `<span class="provider-inuse">${t('settings.providerInUse')}</span>` : isIncluded ? `<span class="provider-inuse">${t('settings.providerIncluded')}</span>` : ''}
            </div>
            <span class="provider-line is-type">${escapeHtml(preset ? t('settings.providerKind.free') + ' · ' + preset.source : t('settings.providerKind.' + providerType(p.type).id) + (p.shared || !hostOf(p) ? '' : ' · ' + hostOf(p)))}</span>
            ${p.shared ? `<span class="provider-line is-shared"><span class="mi">group</span>${escapeHtml(t('share.providerBy', { who: p.sharedBy || '' }))}</span>` : Array.isArray(p.sharedWith) && p.sharedWith.length ? `<span class="provider-line is-shared"><span class="mi">group</span>${escapeHtml(t('share.providerWith', { n: p.sharedWith.length }))}</span>` : ''}
            ${lines.join('')}
            ${isIncluded ? contributionLine(p) : current ? partialLine(catalog._primary) : ''}
        </div>
        <div class="provider-actions" data-nav-row data-nav-reach>
            <button type="button" class="provider-switch" role="switch" aria-checked="${active}" data-provider-toggle="${escapeHtml(p.id)}" aria-label="${escapeHtml(t('settings.providerSwitch', { name: p.name || (p.shared ? '' : hostOf(p)) }))}"><span class="provider-switch-text">${t(active ? 'settings.providerOn' : 'settings.providerOff')}</span><span class="switch ${active ? 'is-on' : ''}" aria-hidden="true"></span></button>
            <button type="button" class="btn btn-icon" data-provider-more="${escapeHtml(p.id)}" aria-haspopup="true" aria-label="${escapeHtml(t('common.moreOptions') + ': ' + (p.name || ''))}"><span class="mi">more_vert</span></button>
        </div>
    </div>`;
}

/* ---------------------------------------------------------------- pestaña «Fuentes» */

let srcFilter = 'all';
let srcQuery = '';
const srcOpen = new Set(); // filas del móvil con las cifras desplegadas («Ver más»)
const countsAsked = new Set(); // proveedores cuyos recuentos ya se han pedido a la base de datos en esta sesión

/** Canales, películas y series de una fuente: lo que hay en memoria o, si no, lo anotado al guardar su catálogo. */
function countsOf(p, current) {
    const data = current ? catalog._primary : (catalog.sources.get(p.id) || {}).data;
    if (data && (data.live || data.vod || data.series)) return { live: (data.live || []).length, vod: (data.vod || []).length, series: (data.series || []).length };
    return catalogStore.counts(p.id);
}

/** Todo lo que necesitan la fila y la pantalla de una fuente (ver sources-ui.js). */
function sourceVm(p, current) {
    const st = providers.get(p, { simulate: current ? catalog.simulate : '' });
    const state = stateOf(p, st);
    const sub = st.sub;
    const isIncluded = !current && included().indexOf(p.id) !== -1;
    const active = current || isIncluded;
    const preset = presetOf(p);
    const kind = providerType(p.type);
    const src = current ? null : catalog.sources.get(p.id);
    const data = current ? catalog._primary : src && src.data;
    const loadFailed = !!(src && src.error && !src.data);
    const partial = !!(data && data.partial && data.partial.length);
    const expired = sub.state === 'expired' || sub.state === 'disabled';
    const issue = st.error === 'auth' || st.error === 'network' || loadFailed || partial || expired;
    const counts = countsOf(p, current);
    if (!counts && !countsAsked.has(p.id)) { countsAsked.add(p.id); catalogStore.ensureCounts(p.id).then((c) => { if (c) srcRepaint(); }); }
    const at = catalogStore.updatedAt(p.id);
    let expiry = null;
    if (kind.group === 'iptv' && !preset && sub.state !== 'none' && sub.expiresAt) {
        expiry = expired || sub.daysLeft < 0
            ? { expired: true, label: t('src.expiredLabel'), text: t('src.daysAgo', { n: Math.max(0, -sub.daysLeft) }) }
            : { expired: false, label: t('src.expires'), text: t('src.days', { n: sub.daysLeft }) };
    }
    const host = hostOf(p);
    const name = p.name || (p.shared ? t('share.sharedName') : host);
    const subtitle = (preset ? t('settings.providerKind.free') + ' · ' + preset.source : t('settings.providerKind.' + kind.id) + (p.shared || !host ? '' : ' · ' + host)).replace(/ · /g, ' • ');
    const errorText = st.error === 'auth' ? t('sub.rejectedText') : expired && !st.error ? t('sub.state.' + sub.state) : partial && data ? t('settings.providerPartial', { what: data.partial.map((k) => t(k === 'live' ? 'common.channels' : k === 'vod' ? 'common.movies' : 'common.series')).join(', ') }) : t('src.loadError');
    return {
        id: p.id, name, icon: preset ? preset.icon : kind.icon, subtitle, current, active, free: !!preset,
        status: issue ? 'issue' : active ? 'ok' : 'off', stateKey: state.key, stateLabel: state.label,
        liveFirst: kind.group === 'iptv' || (!!preset && kind.id !== 'archive' && p.type !== 'archive'),
        open: srcOpen.has(p.id), counts, updatedAt: at, stale: !!at && settings.get('catalogAuto') !== false && Date.now() - at > 36 * 3600 * 1000,
        expiry, errorText, shared: !!p.shared, sub, host
    };
}

function providersHtml(list, current) {
    const vms = list.map((p) => sourceVm(p, !!current && current.id === p.id));
    return panelHtml(vms, { lang: i18n.lang }) + `<div class="settings-group providers-group" data-tab="sources">
        ${list.length > 1 ? `<p class="provider-hint">${escapeHtml(t('settings.providersHint'))}</p>` : ''}
        ${catalog.libraryProviderIds().length ? item({ icon: 'video_library', title: t('settings.onlyLibraries'), sub: t('settings.onlyLibrariesSub'), toggle: catalog.onlyLibraries, action: 'onlyLibraries' }) : ''}
        ${catalog.libraryProviderIds().length ? item({ icon: 'sync', title: t('settings.syncServers'), sub: t('settings.syncServersSub'), toggle: settings.get('syncServers') !== false, action: 'syncServers' }) : ''}
        ${account.signedIn ? item({ icon: 'redeem', title: t('share.redeem'), sub: t('share.redeemSub'), action: 'redeemweb' }) : ''}
        ${account.signedIn ? item({ icon: 'mark_email_unread', title: t('access.title'), sub: accessPending ? t('access.pendingN', { n: accessPending }) : t('access.sub'), action: 'accessrequests' }) : ''}
    </div>`;
}

/** Repintado de la lista desde fuera del montaje (cuando llegan los recuentos). Lo pone mount(). */
let srcRepaint = () => {};
/** La ventana «Fuentes» abierta (o null): su lista se repinta cuando llegan datos nuevos. */
let srcModal = null;

const SIMULATE = [['', 'settings.simulateOff'], ['expiring', 'settings.simulateSoon'], ['expired', 'settings.simulateExpired']];

export default {
    path: '/settings/',
    nav: 'settings',

    render() {
        return `<div class="page" data-name="settings"><div class="page-content">${pageHead({ title: t('settings.title') })}<div data-body></div></div></div>`;
    },

    mount(page) {
        const root = page.el;
        const body = root.querySelector('[data-body]');
        tvOpen = tvOpenNext;
        tvOpenNext = false;
        // Estilo Fire TV: el detalle de la derecha sigue al foco (y al ratón), y «Atrás» dentro de un apartado vuelve a la rejilla.
        body.addEventListener('focusin', () => {
            const pane = body.querySelector(':scope > [data-tvs-detail]');
            if (pane && !pane.classList.contains('is-list')) pane.innerHTML = tvDetailHtml(body);
        });
        body.addEventListener('mouseover', (e) => {
            const pane = body.querySelector(':scope > [data-tvs-detail]');
            const row = e.target.closest ? e.target.closest('.setting') : null;
            if (pane && row && !pane.classList.contains('is-list')) pane.innerHTML = tvDetailHtml(body, row);
        });
        const tvBack = () => {
            if (!tvLayout() || !tvOpen || !body.isConnected) return false;
            tvOpen = false;
            applySettingsTabs(body);
            const tile = body.querySelector('[data-settings-tab="' + activeTab + '"]');
            if (tile && tvMode() && window.IPTV && window.IPTV.tvnav) window.IPTV.tvnav.focus(tile);
            return true;
        };
        window.IPTV.settingsBack = tvBack;

        const currentVms = () => {
            const cur = profiles.current();
            return profiles.list().map((p) => sourceVm(p, !!cur && cur.id === p.id));
        };
        srcRepaint = () => {
            if (body.isConnected) paint();
            if (srcModal) srcModal.repaint();
        };

        /**
         * La lista de fuentes en una ventana modal («Ver fuentes»): con muchas fuentes, navegar por la pestaña se hacía pesado.
         * Dentro: cajas de resumen que filtran, buscador y la lista; cada fila abre su pantalla.
         */
        const openSourcesModal = (filter = 'all') => {
            if (srcModal) return;
            srcFilter = filter;
            srcQuery = '';
            const popupId = 'srcs-' + Date.now().toString(36);
            const offs = [];
            let el = null;
            const repaint = () => {
                if (!el) return;
                const vms = currentVms();
                const chips = el.querySelector('.src-modal-head .src-summary');
                if (chips) chips.outerHTML = summaryHtml(vms, srcFilter);
                const box = el.querySelector('.src-list');
                if (box) box.innerHTML = listHtml(vms, { filter: srcFilter, query: srcQuery, lang: i18n.lang });
            };
            const popup = app.popup.create({
                content: `<div class="popup catpick-popup src-popup src-list-popup" id="${popupId}"><div class="page">
                    <div class="navbar"><div class="navbar-bg"></div><div class="navbar-inner"><div class="title">${escapeHtml(t('src.listTitle'))}</div><div class="right"><a href="#" class="link popup-close btn-icon" aria-label="${escapeHtml(t('common.close'))}"><span class="mi">close</span></a></div></div></div>
                    <div class="page-content" data-src-modal-body></div></div></div>`,
                on: {
                    open(pp) {
                        el = pp.$el[0];
                        el.querySelector('[data-src-modal-body]').innerHTML = modalHtml(currentVms(), { filter: srcFilter, query: srcQuery, lang: i18n.lang });
                        const again = debounce(repaint, 250);
                        offs.push(catalog.on('change', again), catalog.on('sources', again), providers.on('change', again));
                        el.addEventListener('input', (e) => {
                            const input = e.target.closest('[data-src-search]');
                            if (!input) return;
                            srcQuery = input.value;
                            repaint();
                        });
                        el.addEventListener('click', (e) => {
                            const flt = e.target.closest('[data-src-filter]');
                            if (flt) {
                                srcFilter = flt.getAttribute('data-src-filter');
                                repaint();
                                return;
                            }
                            handleRowClick(e);
                        });
                    },
                    opened(pp) { if (device.isTV) setTimeout(() => window.IPTV.tvnav.focusLayer(pp.$el[0]), 80); },
                    closed() {
                        srcModal = null;
                        offs.splice(0).forEach((fn) => fn());
                        try { popup.destroy(); } catch (e) { /* ignore */ }
                        const node = document.getElementById(popupId);
                        if (node && node.parentNode) node.parentNode.removeChild(node);
                    }
                }
            });
            srcModal = { repaint };
            popup.open();
        };

        /** La pantalla de una fuente (ventana modal): cifras, información, contenido en el catálogo y acciones. */
        const openSourceDetail = (id) => {
            const popupId = 'src-' + Date.now().toString(36);
            const infoOf = (p, vm) => {
                const kindLabel = vm.free ? t('settings.providerKind.free') : t('settings.providerKind.' + providerType(p.type).id).replace(/ · /g, ' • ');
                const rows = [[t('src.kind'), kindLabel]];
                if (vm.host && !p.shared) rows.push([t('src.server'), vm.host]);
                if (vm.sub && vm.sub.state !== 'none' && (vm.sub.max || vm.sub.active)) rows.push([t('src.connections'), t('src.of', { a: vm.sub.active, b: vm.sub.max || '∞' })]);
                rows.push([t('src.state'), vm.status === 'issue' ? vm.errorText : vm.status === 'off' ? t('src.f.off') : (vm.stateKey === 'active' || vm.stateKey === 'unknown' || vm.stateKey === 'list' ? t('src.ok') : vm.stateLabel), { ok: vm.status === 'ok', warn: vm.status === 'issue' }]);
                const c = vm.counts;
                const content = [];
                if (c) {
                    content.push([t('src.movies'), fmtNum(c.vod, i18n.lang)], [t('src.series'), fmtNum(c.series, i18n.lang)], [t('src.channels'), fmtNum(c.live, i18n.lang)]);
                    const ms = catalog.mergeStats[p.id];
                    if (ms) { const n = ms.live.merged + ms.vod.merged + ms.series.merged; if (n) content.push([t('src.repeated'), fmtNum(n, i18n.lang)]); }
                }
                const actions = [];
                if (!p.shared && !account.demo) actions.push({ id: 'edit', icon: 'edit', label: t('src.edit') }, { id: 'duplicate', icon: 'content_copy', label: t('src.duplicate') });
                if ((account.signedIn && !p.shared && !account.demo)) actions.push({ id: 'share', icon: 'ios_share', label: t('src.share') });
                if (!account.demo) actions.push({ id: 'delete', icon: p.shared ? 'link_off' : 'delete', label: t(p.shared ? 'share.leave' : 'src.delete'), danger: true });
                return { rows, content, actions };
            };
            const render = () => {
                const p = profiles.get(id);
                const el = document.getElementById(popupId);
                if (!el) return;
                if (!p) { popup.close(); return; }
                const cur = profiles.current();
                const vm = sourceVm(p, !!cur && cur.id === id);
                el.querySelector('[data-src-body]').innerHTML = detailHtml(vm, infoOf(p, vm), i18n.lang);
            };
            const offs = [];
            const popup = app.popup.create({
                content: `<div class="popup catpick-popup src-popup" id="${popupId}"><div class="page">
                    <div class="navbar"><div class="navbar-bg"></div><div class="navbar-inner"><div class="title">${escapeHtml(t('src.detail'))}</div><div class="right"><a href="#" class="link popup-close btn-icon" aria-label="${escapeHtml(t('common.close'))}"><span class="mi">close</span></a></div></div></div>
                    <div class="page-content" data-src-body></div></div></div>`,
                on: {
                    open(pp) {
                        const el = pp.$el[0];
                        render();
                        const again = debounce(render, 250);
                        offs.push(catalog.on('change', again), catalog.on('sources', again), providers.on('change', again));
                        el.addEventListener('click', async (e) => {
                            if (e.target.closest('[data-provider-toggle]')) { await handlers.toggle(id); setTimeout(render, 200); return; }
                            if (e.target.closest('[data-src-refresh]')) { await handlers.refreshSource(id); render(); return; }
                            const act = e.target.closest('[data-src-action]');
                            if (!act) return;
                            const p = profiles.get(id);
                            const which = act.getAttribute('data-src-action');
                            popup.close();
                            if (!p) return;
                            if (which === 'edit') (p.type === 'smb' || p.type === 'local' || p.type === 'dropbox' || p.type === 'onedrive') ? window.IPTV.openAddSource({ edit: id }) : app.views.main.router.navigate('/profile/' + id + '/');
                            else if (which === 'duplicate') handlers.duplicate(id);
                            else if (which === 'share') handlers.shareProvider(id);
                            else if (which === 'delete') handlers.remove(id);
                        });
                    },
                    opened(pp) { if (device.isTV) setTimeout(() => window.IPTV.tvnav.focusLayer(pp.$el[0]), 80); },
                    closed() {
                        offs.splice(0).forEach((fn) => fn());
                        try { popup.destroy(); } catch (e) { /* ignore */ }
                        const el = document.getElementById(popupId);
                        if (el && el.parentNode) el.parentNode.removeChild(el);
                    }
                }
            });
            popup.open();
        };
        // Deslizador de la transparencia del menú: se ve al momento y se guarda al moverlo.
        body.addEventListener('input', (e) => {
            const r = e.target.closest && e.target.closest('[data-nav-fade]');
            if (!r) return;
            const v = Number(r.value);
            settings.set('navFade', v);
            window.IPTV.actions.applyUiSettings();
            const lab = body.querySelector('[data-nav-fade-val]');
            if (lab) lab.textContent = v + ' %';
        });
        body.addEventListener('click', (e) => {
            if (e.target.closest('[data-tvs-back]')) { e.preventDefault(); e.stopPropagation(); tvBack(); return; }
            const tab = e.target.closest('[data-settings-tab]');
            if (!tab) return;
            e.preventDefault();
            e.stopPropagation();
            activeTab = tab.getAttribute('data-settings-tab');
            try { localStorage.setItem('iptv:' + TAB_KEY, activeTab); } catch (err) { /* sin almacenamiento */ }
            if (tvLayout()) tvOpen = true; // en la tele (o con la opción activada), el mosaico abre sus tres columnas
            applySettingsTabs(body);
            const nav = window.IPTV && window.IPTV.tvnav;
            if (tvLayout() && tvMode() && nav) {
                const first = body.querySelector('.settings-group:not(.is-off-tab) .setting, .settings-group:not(.is-off-tab) button, .settings-group:not(.is-off-tab) [data-focusable]');
                if (first) nav.focus(first);
                return;
            }
            const again = body.querySelector('[data-settings-tab="' + activeTab + '"]');
            if (again && nav && (device.isTV || document.documentElement.classList.contains('mode-tv'))) nav.focus(again, { scroll: false });
        });
        let usage = 0;
        db.estimate().then((u) => { usage = u; paint(); });
        if (account.signedIn) pendingRequestCount().then((n) => { if (n !== accessPending) { accessPending = n; paint(); } });
        // Catálogos guardados antes de que existieran los sellos de fecha: se leen una vez para enseñar su fecha.
        Promise.all(profiles.list().map((p) => (catalogStore.updatedAt(p.id) ? 0 : catalogStore.stamp(p.id)))).then((r) => { if (r.some(Boolean)) paint(); });

        const paint = () => {
            const s = settings.all();
            const current = profiles.current();
            const list = profiles.list();
            const langName = s.lang === 'auto' ? t('common.auto') : (i18n.available.find((l) => l.code === s.lang) || {}).name;
            const tvLabel = s.tvMode === 'auto' ? t('common.auto') + (device.isTV ? ' (TV)' : '') : s.tvMode === 'on' ? t('common.on') : t('common.off');
            const u = account.user;
            // Cuenta de la demo pública: sin ajustes que gestionar; solo qué es la demo, los textos legales y la salida.
            if (account.demo) {
                body.innerHTML = [group(t('settings.filoteca'), [
                    item({ icon: 'science', title: t('demo.settingsTitle'), sub: t('demo.settingsSub') }),
                    `<a class="setting external" href="${escapeHtml(account.baseUrl())}/legal/terms.html" target="_blank" rel="noopener"><span class="mi">gavel</span><span class="setting-body"><span class="setting-title">${t('settings.termsLink')}</span><span class="setting-sub">${escapeHtml(termsSub())}</span></span><span class="mi">open_in_new</span></a>`,
                    `<a class="setting external" href="${escapeHtml(account.baseUrl())}/legal/privacy.html" target="_blank" rel="noopener"><span class="mi">privacy_tip</span><span class="setting-body"><span class="setting-title">${t('settings.privacyLink')}</span></span><span class="mi">open_in_new</span></a>`
                ])].join(''); // sin «salir»: la demo no se abandona por voluntad propia, termina sola
                applySettingsTabs(body);
                return;
            }
            const viewer = viewers.current();
            body.innerHTML = [
                group(t('settings.viewers'), [
                    `<a class="setting" href="#" data-href="/who/"><span class="who-avatar is-small" style="background:${viewer ? avatarColor(viewer) : 'var(--surface-2)'}">${escapeHtml(avatarInitial(viewer))}</span><span class="setting-body"><span class="setting-title">${escapeHtml(viewer ? viewer.name : '—')}${viewer && viewer.kids ? ' · ' + t('who.kids') : ''}</span><span class="setting-sub">${t('settings.currentViewer')}</span></span><span class="setting-value">${t('settings.switchViewer')}</span><span class="mi">chevron_right</span></a>`,
                    item({ icon: 'manage_accounts', title: t('who.manage'), href: '/who/' }),
                    item({ icon: 'timer', title: t('settings.viewerAuto'), sub: t('settings.viewerAutoSub'), value: Number(s.viewerAutoPick) === 0 ? t('settings.viewerAutoOff') : t('settings.heroIntervalSec', { n: Number.isFinite(Number(s.viewerAutoPick)) ? Number(s.viewerAutoPick) : 6 }), action: 'viewerauto' })
                ]),
                account.demo ? group(t('settings.filoteca'), [
                    item({ icon: 'science', title: t('demo.settingsTitle'), sub: t('demo.settingsSub') }),
                    `<a class="setting external" href="${escapeHtml(account.baseUrl())}/legal/terms.html" target="_blank" rel="noopener"><span class="mi">gavel</span><span class="setting-body"><span class="setting-title">${t('settings.termsLink')}</span><span class="setting-sub">${escapeHtml(termsSub())}</span></span><span class="mi">open_in_new</span></a>`,
                    `<a class="setting external" href="${escapeHtml(account.baseUrl())}/legal/privacy.html" target="_blank" rel="noopener"><span class="mi">privacy_tip</span><span class="setting-body"><span class="setting-title">${t('settings.privacyLink')}</span></span><span class="mi">open_in_new</span></a>`,
                    item({ icon: 'logout', title: t('demo.exit'), action: 'signout', danger: true })
                ]) : account.signedIn ? group(t('settings.filoteca'), [
                    item({ icon: 'account_circle', title: u.name || u.email, sub: u.name ? u.email : t('settings.signedAs'), value: u.role === 'admin' ? t('admin.roleAdmin') : '' }),
                    item({ icon: 'tv', title: t('settings.pairTv'), sub: t('settings.pairTvSub'), href: '/pair/' }),
                    item({ icon: 'devices', title: t('settings.devices'), sub: t('settings.devicesSub'), action: 'devices' }),
                    account.isAdmin ? item({ icon: 'verified_user', title: t('twofa.title'), sub: t('twofa.sub'), value: u.twofa ? t('twofa.on') : t('twofa.off'), action: 'twofa' }) : '',
                    account.isAdmin ? item({ icon: 'manage_accounts', title: t('settings.users'), sub: t('settings.usersSub'), action: 'users' }) : '',
                    account.isAdmin ? item({ icon: 'payments', title: t('settings.paymentsAdmin'), sub: t('settings.paymentsAdminSub'), action: 'paymentsAdmin' }) : '',
                    account.isAdmin ? item({ icon: 'vpn_key', title: t('settings.licensesAdmin'), sub: t('settings.licensesAdminSub'), action: 'licensesAdmin' }) : '',
                    account.isAdmin ? item({ icon: 'dashboard', title: t('catstatus.title'), sub: t('catstatus.sub'), action: 'catalogStatus' }) : '',
                    account.isAdmin ? item({ icon: 'rate_review', title: t('catreview.title'), sub: t('catreview.sub'), action: 'catalogReview' }) : '',
                    account.isAdmin ? item({ icon: 'monitoring', title: t('usage.title'), sub: t('usage.sub'), action: 'usageAdmin' }) : '',
                    account.isAdmin ? item({ icon: 'gavel', title: t('reports.admin.title'), sub: t('reports.admin.sub'), action: 'reportsAdmin' }) : '',
                    account.isAdmin ? item({ icon: 'fact_check', title: t('survey.admin.title'), sub: t('survey.admin.sub'), action: 'surveyAdmin' }) : '',
                    account.isAdmin ? item({ icon: 'description', title: t('docs.admin.title'), sub: t('docs.admin.sub'), action: 'docsAdmin' }) : '',
                    account.isAdmin ? item({ icon: 'view_carousel', title: t('heroAdmin.title'), sub: t('heroAdmin.sub'), action: 'heroAdmin' }) : '',
                    `<a class="setting external" href="${escapeHtml(account.baseUrl())}/legal/terms.html" target="_blank" rel="noopener"><span class="mi">gavel</span><span class="setting-body"><span class="setting-title">${t('settings.termsLink')}</span><span class="setting-sub">${escapeHtml(termsSub())}</span></span><span class="mi">open_in_new</span></a>`,
                    `<a class="setting external" href="${escapeHtml(account.baseUrl())}/legal/privacy.html" target="_blank" rel="noopener"><span class="mi">privacy_tip</span><span class="setting-body"><span class="setting-title">${t('settings.privacyLink')}</span></span><span class="mi">open_in_new</span></a>`,
                    account.passwordAuth ? item({ icon: 'password', title: t(u.hasPassword ? 'settings.changePassword' : 'settings.setPassword'), sub: t('settings.passwordSub'), action: 'changepassword' }) : '',
                    item({ icon: 'logout', title: t('settings.signOutGoogle'), action: 'signout', danger: true }),
                    item({ icon: 'delete_forever', title: t('settings.deleteAccount'), sub: t('settings.deleteAccountSub'), action: 'deleteaccount', danger: true })
                ]) : '',
                providersHtml(list, current),
                group(t('settings.appearance'), [
                    item({ icon: 'language', title: t('settings.language'), value: langName, action: 'lang' }),
                    device.isTV ? '' : item({ icon: 'grid_view', title: t('settings.fireLayout'), sub: t('settings.fireLayoutSub'), toggle: s.fireLayout === true, action: 'toggle:fireLayout' }),
                    item({ icon: 'tv', title: t('settings.tvMode'), sub: t('settings.tvModeSub'), value: tvLabel, action: 'tvmode' }),
                    item({ icon: 'auto_awesome', title: t('settings.intro'), sub: t('settings.introSubWeb'), toggle: s.introAnim !== false, action: 'toggle:introAnim' }),
                    s.introAnim !== false ? item({ icon: 'volume_up', title: t('settings.introSound'), toggle: s.introSound !== false, action: 'toggle:introSound' }) : '',
                    s.introAnim !== false ? item({ icon: 'play_circle', title: t('settings.introPlay'), action: 'introPlay' }) : '',
                    item({ icon: 'waving_hand', title: t('settings.welcome'), sub: t('settings.welcomeSub'), action: 'welcome' }),
                    item({ icon: 'tips_and_updates', title: t('settings.coach'), sub: t('settings.coachSub'), toggle: s.coach !== false, action: 'toggle:coach' }),
                    s.coach !== false ? item({ icon: 'restart_alt', title: t('settings.coachReset'), action: 'coachReset' }) : '',
                    item({ icon: 'image', title: t('settings.cardsPosterOnly'), sub: t('settings.cardsPosterOnlySub'), toggle: !!s.cardsPosterOnly, action: 'toggle:cardsPosterOnly' }),
                    (device.isTV || window.innerWidth >= 900) ? (device.isTV
                        ? item({ icon: 'gradient', title: t('settings.navFade'), sub: t('settings.navFadeSub'), value: navFadeValue(s) + ' %', action: 'navfade' })
                        : navFadeRow(s)) : '',
                    item({ icon: 'format_size', title: t('settings.uiScale'), value: Math.round(s.uiScale * 100) + '%', action: 'scale' }),
                    item({ icon: 'auto_awesome', title: t('settings.shell'), sub: t('settings.shellSub'), value: (shellById(s.shell || 'cine').custom ? shellById(s.shell).name : t('shell.' + shellById(s.shell || 'cine').id)), action: 'shell' }),
                    (s.shell || 'cine') === 'cine' ? item({ icon: s.theme === 'light' ? 'light_mode' : s.theme === 'auto' ? 'brightness_auto' : 'dark_mode', title: t('settings.theme'), value: t(s.theme === 'light' ? 'settings.themeLight' : s.theme === 'auto' ? 'settings.themeAuto' : 'settings.themeDark'), action: 'theme' }) : '',
                    item({ icon: 'palette', title: t('settings.skin'), sub: t('settings.skinSub'), value: t('skin.' + skinById(s.skin).id), action: 'skin' }),
                    item({ icon: 'recommend', title: t('settings.similarByTaste'), sub: t('settings.similarByTasteSub'), toggle: s.similarByTaste !== false, action: 'toggle:similarByTaste' }),
                    item({ icon: 'live_tv', title: t('settings.continueChannels'), sub: t('settings.continueChannelsSub'), toggle: s.continueChannels !== false, action: 'toggle:continueChannels' }),
                    item({ icon: 'slideshow', title: t('settings.heroInterval'), sub: t('settings.heroIntervalSub'), value: Number(s.heroInterval) === 0 ? t('settings.heroIntervalOff') : t('settings.heroIntervalSec', { n: Number.isFinite(Number(s.heroInterval)) ? Number(s.heroInterval) : 8 }), action: 'herointerval' }),
                    item({ icon: 'volume_up', title: t('settings.uiSounds'), sub: t('settings.uiSoundsSub'), value: t('settings.uiSounds' + (s.uiSounds === 'on' ? 'On' : s.uiSounds === 'off' ? 'Off' : 'Auto')), action: 'uisounds' }),
                    item({ icon: 'photo_size_select_small', title: t('settings.compactLiveRow'), sub: t('settings.compactLiveRowSub'), toggle: s.compactLiveRow !== false, action: 'toggle:compactLiveRow' }),
                    account.enabled || account.tmdb ? item({ icon: 'leaderboard', title: t('settings.top10'), sub: t('settings.top10Sub'), value: t('settings.top10_' + (s.topSource || 'own')), action: 'top10source' }) : '',
                    item({ icon: 'filter_alt', title: t('settings.homeFilters'), sub: t('settings.homeFiltersSub'), toggle: s.homeFilters !== false, action: 'toggle:homeFilters' }),
                    item({ icon: 'view_carousel', title: t('settings.libraryHero'), sub: t('settings.libraryHeroSub'), toggle: s.libraryHero !== false, action: 'toggle:libraryHero' }),
                    s.libraryHero !== false ? item({ icon: 'layers', title: t('settings.libraryBarOverlay'), sub: t('settings.libraryBarOverlaySub'), toggle: s.libraryBarOverlay === true, action: 'toggle:libraryBarOverlay' }) : '',
                    (device.hasHover || device.isTV) ? item({ icon: 'open_in_full', title: t('settings.peekCard'), sub: t('settings.peekCardSub'), toggle: s.peekCard !== false, action: 'toggle:peekCard' }) : '',
                    (device.hasHover || device.isTV) && s.peekCard !== false ? item({ icon: 'view_carousel', title: t('settings.peekStyle'), sub: t('settings.peekStyleSub'), value: t(s.peekStyle === 'float' ? 'settings.peekStyle.float' : 'settings.peekStyle.row'), action: 'peekstyle' }) : '',
                    item({ icon: 'view_agenda', title: t('settings.episodeView'), sub: t('settings.episodeViewSub'), value: t(s.episodeView === 'cards' ? 'settings.viewCards' : s.episodeView === 'list' ? 'settings.viewList' : 'settings.viewAuto'), action: 'episodeview' }),
                    item({ icon: 'subject', title: t('settings.detailHeader'), sub: t('settings.detailHeaderSub'), value: t(s.detailHeader === 'full' ? 'settings.detailFull' : 'settings.detailSummary'), action: 'detailheader' }),
                    item({ icon: 'smart_display', title: t('settings.trailerButton'), sub: t('settings.trailerButtonSub'), toggle: !!s.trailerButton, action: 'toggle:trailerButton' })
                ]),
                group(t('settings.playback'), [
                    spotify.configuredSync() ? item({ icon: 'music_note', title: t('spotify.setting'), sub: spotify.linked() ? t('spotify.linkedSub', { name: spotify.name() || 'Spotify' }) : t('spotify.notLinked'), action: 'spotify' }) : '',
                    item({ icon: 'skip_next', title: t('settings.autoplayNext'), toggle: !!s.autoplayNext, action: 'toggle:autoplayNext' }),
                    item({ icon: 'timer', title: t('settings.nextOffer'), sub: t('settings.nextOfferSub'), value: nextOfferLabel(s.nextOfferSec), action: 'nextoffer' }),
                    item({ icon: 'preview', title: t('settings.autoplayPreview'), sub: t('settings.autoplayPreviewSub'), toggle: s.autoplayPreview !== false, action: 'toggle:autoplayPreview' }),
                    device.isTV ? '' : item({ icon: 'photo_size_select_large', title: t('settings.seekPreview'), sub: t('settings.seekPreviewSub'), toggle: s.seekPreview !== false, action: 'toggle:seekPreview' }),
                    item({ icon: 'history', title: t('settings.rememberPosition'), toggle: !!s.rememberPosition, action: 'toggle:rememberPosition' }),
                    (device.isTV || device.hasHover) ? item({ icon: 'settings_remote', title: t('settings.liveOk'), sub: t('settings.liveOkSub'), value: t(s.liveOkAction === 'pause' ? 'settings.liveOkPause' : 'settings.liveOkChannels'), action: 'liveok' }) : '',
                    item({ icon: 'dashboard', title: t('settings.liveView'), sub: t('settings.liveViewSub'), value: t('live.view' + ({ grid: 'Grid', list: 'List', panel: 'Panel' }[s.liveView] || 'Rows')), action: 'liveview' }),
                    item({ icon: 'view_carousel', title: t('settings.channelListStyle'), sub: t('settings.channelListStyleSub'), value: t(s.channelListStyle !== 'panel' ? 'settings.channelListStrip' : 'settings.channelListPanel'), action: 'channelliststyle' }),
                    item({ icon: 'view_list', title: t('settings.liveInfoStyle'), sub: t('settings.liveInfoStyleSub'), value: t(s.liveInfoStyle === 'simple' ? 'settings.liveInfoSimple' : 'settings.liveInfoGuide'), action: 'liveinfostyle' }),
                    item({ icon: 'bolt', title: t('settings.prefetchFocus'), sub: t('settings.prefetchFocusSub'), toggle: s.prefetchFocus !== false, action: 'toggle:prefetchFocus' }),
                    item({ icon: 'high_quality', title: t('settings.liveQuality'), sub: t('settings.liveQualitySub'), value: t(s.liveQuality === 'best' ? 'settings.liveQualityBest' : s.liveQuality === 'saver' ? 'settings.liveQualitySaver' : 'settings.liveQualityAuto'), action: 'livequality' }),
                    item({ icon: 'stream', title: t('settings.liveFormat'), sub: t('settings.liveFormatSub'), value: s.liveFormat.toUpperCase(), action: 'liveformat' }),
                    (account.transcode || transcodeAvailable()) ? item({ icon: 'graphic_eq', title: t('settings.transcodeAudio'), sub: t('settings.transcodeAudioSub'), value: transcodeLabel(s.transcodeAudio), action: 'transcode' }) : '',
                    account.subtitles ? item({ icon: 'subtitles', title: t('settings.subtitlesAuto'), sub: t('settings.subtitlesAutoSub'), toggle: !!s.subtitlesAuto, action: 'toggle:subtitlesAuto' }) : '',
                    account.subtitles ? item({ icon: 'translate', title: t('settings.subtitleLang'), value: (SUB_LANGS.find((l) => l[0] === s.subtitleLang) || ['', s.subtitleLang])[1], action: 'subtitlelang' }) : ''
                ]),
                group(t('settings.parental'), [
                    item({ icon: 'lock', title: t('settings.parentalEnable'), toggle: !!s.parental.enabled, action: 'parental' }),
                    s.parental.enabled ? item({ icon: 'pin', title: t('settings.parentalPin'), action: 'pin' }) : '',
                    s.parental.enabled ? item({ icon: 'category', title: t('settings.parentalCategories'), value: String(Object.keys(s.parental.categories).filter((k) => s.parental.categories[k]).length + catalog.categories.live.concat(catalog.categories.vod, catalog.categories.series).filter((c) => c.adult).length), action: 'parentalcats' }) : ''
                ]),
                account.canRecord ? group(t('rec.title'), [
                    item({ icon: 'fiber_manual_record', title: t('rec.manage'), sub: t('rec.limitsSub', { min: account.recordings.maxMinutes, gb: account.recordings.quotaGb, days: account.recordings.retentionDays }), href: '/recordings/' })
                ]) : '',
                group(t('settings.data'), [
                    item({ icon: 'sync', title: t('settings.refreshCatalog'), sub: t('settings.refreshCatalogSub'), action: 'refresh' }),
                    item({ icon: 'video_library', title: t('settings.catalogOn'), sub: t('settings.catalogOnSub'), toggle: s.catalogOn !== false, action: 'toggle:catalogOn' }),
                    account.tmdb ? item({ icon: 'movie_filter', title: t('settings.tmdbMode'), sub: t('settings.tmdbModeSub'), value: t('settings.tmdbMode.' + (s.tmdbMode || 'auto')), action: 'tmdbmode' }) : '',
                    account.omdb ? item({ icon: 'star_rate', title: t('settings.omdbWeb'), sub: t('settings.omdbWebSub'), toggle: s.omdbOn !== false, action: 'omdbweb' }) : '',
                    item({ icon: 'update', title: t('settings.catalogAuto'), sub: t('settings.catalogAutoSub'), toggle: s.catalogAuto !== false, action: 'toggle:catalogAuto' }),
                    item({ icon: 'calendar_month', title: t('settings.refreshEpg'), sub: epg.updated ? t('settings.epgUpdated', { date: new Date(epg.updated).toLocaleString(i18n.lang) }) : t('settings.epgNever'), action: 'epg' }),
                    item({ icon: 'cleaning_services', title: t('settings.clearCache'), sub: t('settings.clearCacheSub') + (usage ? ' · ' + formatBytes(usage) : ''), action: 'clear' })
                ]),
                group(t('settings.network'), [
                    item({ icon: 'vpn_lock', title: t('settings.proxy'), sub: t('settings.proxySub'), value: s.proxyUrl ? s.proxyUrl : t('common.off'), action: 'proxy' }),
                    device.isCordova || device.isElectron ? item({ icon: 'dns', title: t('settings.serverUrl'), sub: t('settings.serverUrlSub'), value: s.serverUrl || 'filoteca.com', action: 'server' }) : ''
                ]),
                devMode.on() ? group(t('dev.group'), [
                    item({ icon: 'data_object', title: t('dev.exportConfig'), sub: t('dev.exportConfigSub'), action: 'exportConfig' }),
                    devMode.manual() ? item({ icon: 'code_off', title: t('dev.off'), action: 'devOff' }) : ''
                ]) : '',
                group(t('settings.diagnostics'), [
                    item({ icon: 'restart_alt', title: t('settings.factoryReset'), sub: t('settings.factoryResetSub'), action: 'factoryreset', danger: true }),
                    devMode.on() ? item({ icon: 'science', title: t('settings.simulate'), sub: t('settings.simulateSub'), value: t((SIMULATE.find((o) => o[0] === catalog.simulate) || SIMULATE[0])[1]), action: 'simulate' }) : ''
                ]),
                group(t('settings.about'), [
                    item({ icon: 'info', title: t('app.name'), value: t('settings.version') + ' ' + window.IPTV.version, action: 'devTap' }),
                    item({ icon: 'verified_user', title: t('settings.contentNotice'), sub: t('settings.contentNoticeSub') }),
                    account.tmdb && !catalog._tmdbOff() ? item({ icon: 'movie_filter', title: 'TMDB', sub: t('settings.tmdbAttribution') }) : '',
                    account.omdb ? item({ icon: 'star_rate', title: 'OMDb', sub: t('settings.omdbAttribution') }) : '',
                    s.catalogOn !== false ? item({ icon: 'video_library', title: t('settings.catalogName'), sub: t('settings.catalogAttribution') }) : '',
                    item({ icon: 'volunteer_activism', title: t('settings.credits'), sub: t('settings.creditsSub'), action: 'credits' }),
                    item({ icon: 'flag', title: t('report.title'), sub: t('report.sub'), action: 'report' }),
                    support.enabled ? item({ icon: 'support_agent', title: t('support.title'), sub: t(support.subKey), value: support.unread() ? t('support.unreadValue', { n: support.unread() }) : '', action: 'support' }) : '',
                    device.isCordova || device.isElectron ? item({ icon: 'system_update', title: t('update.check'), sub: window.IPTV.updater.hasUpdate() ? t('update.availableSub', { version: window.IPTV.updater.available() }) : '', action: 'update' }) : '',
                    !device.isCordova && !device.isElectron && account.apkVersion ? `<a class="setting external" href="${escapeHtml(account.baseUrl())}/apk" target="_blank" rel="noopener"><span class="mi">android</span><span class="setting-body"><span class="setting-title">${t('app.downloadApk')}</span><span class="setting-sub">${escapeHtml(t('app.downloadApkSub', { url: account.baseUrl().replace(/^https?:\/\//, '') + '/apk' }))} · ${escapeHtml(account.apkVersion)}</span></span><span class="mi">download</span></a>` : '',
                    item({ icon: 'devices', title: t('settings.platform'), value: device.platformLabel() }),
                    item({ icon: 'memory', title: t('settings.hls'), value: window.Hls ? (window.Hls.isSupported() ? 'hls.js' : device.nativeHls ? 'native' : '—') : window.MediaSource ? 'hls.js' : device.nativeHls ? 'native' : '—' }),
                    account.signedIn ? '' : item({ icon: 'logout', title: t('settings.logout'), action: 'logout', danger: true })
                ])
            ].join('');
            applySettingsTabs(body);
        };

        const app = window.app;
        const actions = window.IPTV.actions;

        const handlers = {
            addsource() { window.IPTV.openAddSource(); },
            twofa() { openTwoFactor({ onChange: paint }); },
            async use(id) {
                const p = profiles.get(id);
                if (!p) return;
                // El que era principal pasa a estar añadido si el nuevo lo estaba: el catálogo no encoge.
                const before = profiles.current();
                const ids = included();
                if (before && before.id !== id && ids.indexOf(id) !== -1) storage.set('includedProfiles', ids.filter((x) => x !== id).concat([before.id]));
                profiles.setCurrent(p.id);
                await actions.activateProfile(p);
                paint();
            },
            /**
             * Interruptor de un proveedor. Uno añadido se activa o desactiva sin más. El principal no
             * puede quedarse sin nadie: al desactivarlo, otro proveedor pasa a ser el principal.
             */
            toggle(id) {
                const current = profiles.current();
                if (!current || current.id !== id) return handlers.include(id);
                const others = profiles.list().filter((x) => x.id !== id);
                if (!others.length) {
                    notify.toast(t('settings.providerOnlyOne'), { icon: 'info', duration: 3500 });
                    return;
                }
                const next = others.find((x) => included().indexOf(x.id) !== -1) || others[0];
                notify.confirm(t('settings.providerOffMain', { name: current.name, next: next.name }), t('settings.providerOffTitle', { name: current.name }), async () => {
                    await handlers.use(next.id);
                    storage.set('includedProfiles', included().filter((x) => x !== current.id));
                    await catalog.loadExtras().catch(() => {});
                    paint();
                });
            },
            /** Suma (o quita) un proveedor al catálogo del principal. */
            async include(id) {
                const ids = included();
                const on = ids.indexOf(id) === -1;
                storage.set('includedProfiles', on ? ids.concat([id]) : ids.filter((x) => x !== id));
                paint();
                await catalog.loadExtras().catch(() => {});
                paint();
                const st = catalog.mergeStats[id];
                if (on && st) notify.toast(t('settings.providerAdded', { n: st.live.added + st.vod.added + st.series.added }), { icon: 'library_add', duration: 2500 });
            },
            async check(id) {
                const p = profiles.get(id);
                if (!p) return;
                notify.toast(t('sub.checking'), { icon: 'sync', duration: 1200 });
                const current = profiles.current();
                const st = current && current.id === id ? { sub: await catalog.checkSubscription(), error: providers.get(p).error } : await providers.check(p);
                paint();
                if (st.error === 'network') notify.error(t('sub.state.offline'));
                else if (st.error === 'auth') notify.error(t('sub.state.rejected'));
                else notify.toast(t('sub.state.' + (st.sub.state === 'none' ? 'unknown' : st.sub.state)), { icon: st.sub.state === 'expired' || st.sub.state === 'disabled' ? 'event_busy' : 'check_circle' });
            },
            /** Vuelve a pedir el catálogo de una fuente (y a comprobar su cuenta). */
            async refreshSource(id) {
                const p = profiles.get(id);
                if (!p) return;
                notify.toast(t('src.refreshing'), { icon: 'sync', duration: 1500 });
                try {
                    if (p.type !== 'm3u') await providers.check(p);
                    if (profiles.current() && profiles.current().id === id) await actions.activateProfile(p, { force: true });
                    else await catalog.loadExtras({ force: true });
                } catch (e) { /* el estado de la fuente ya cuenta el fallo */ }
                paint();
            },
            /** Una copia de la fuente (mismos datos, nombre «… (copia)»): útil para probar otra carpeta o cuenta parecida. */
            async duplicate(id) {
                const p = profiles.get(id);
                if (!p || p.shared) return;
                const copy = Object.assign({}, p, { name: (p.name || hostOf(p) || '') + ' ' + t('src.copySuffix') });
                ['id', 'createdAt', 'updatedAt', 'sharedWith', 'remoteId'].forEach((k) => delete copy[k]);
                if (p.type === 'local') copy.host = 'local://' + Math.random().toString(36).slice(2, 12) + Date.now().toString(36);
                const added = await profiles.add(copy);
                notify.toast(t('src.duplicated', { name: added.name }), { icon: 'content_copy', duration: 2500 });
                paint();
            },
            remove(id) {
                const p = profiles.get(id);
                if (!p) return;
                const wasCurrent = profiles.current() && profiles.current().id === id;
                const downloads = offline.list().filter((r) => r.profileId === id);
                const text = (p.shared ? t('share.leaveConfirm', { name: p.name || t('share.sharedName'), who: p.sharedBy || '' }) : t('settings.deleteProfileConfirm', { name: p.name })) + (downloads.length ? ' ' + t('settings.deleteProviderDownloads', { n: downloads.length }) : '');
                notify.confirm(text, t('settings.deleteProfile'), async () => {
                    try {
                        await profiles.remove(p.id);
                    } catch (e) {
                        notify.error(t('common.errorNetwork'));
                        return;
                    }
                    await catalog.purgeProfile(p.id);
                    providers.forget(p.id);
                    storage.set('includedProfiles', included().filter((x) => x !== p.id));
                    await catalog.loadExtras().catch(() => {});
                    for (const r of downloads) await offline.remove(r.key).catch(() => {});
                    if (!wasCurrent) {
                        paint();
                        return;
                    }
                    const next = profiles.current();
                    if (next) {
                        await actions.activateProfile(next);
                        paint();
                    } else {
                        await catalog.use(null);
                        app.views.main.router.navigate(firstScreen({ needsAccount: account.enabled && !account.signedIn }), { reloadAll: true, clearPreviousHistory: true });
                    }
                });
            },
            more(id, target) {
                const p = profiles.get(id);
                if (!p || account.demo) return;
                const current = profiles.current() && profiles.current().id === id;
                openMenu(target, [
                    current ? null : { icon: 'check_circle', label: t('settings.providerUse'), onClick: () => handlers.use(id) },
                    p.type !== 'm3u' ? { icon: 'refresh', label: t('settings.providerCheck'), onClick: () => handlers.check(id) } : null,
                    // Compartir con otra cuenta: solo el dueño, y solo con sesión (las apps independientes no tienen cuenta).
                    account.signedIn && !p.shared ? { icon: 'group_add', label: t('share.menu'), onClick: () => handlers.shareProvider(id) } : null,
                    // Carpeta de archivos propios con vídeos personales (cámara, familia…): sin carátulas ni fichas de TMDB.
                    ['files', 'smb', 'local', 'dropbox', 'onedrive'].indexOf(p.type) !== -1 && !p.shared ? { icon: p.personal && p.personal !== '0' ? 'check_box' : 'check_box_outline_blank', label: t('settings.providerPersonal'), onClick: () => handlers.personal(id) } : null,
                    p.shared ? null : { icon: 'edit', label: t('settings.editProfile'), onClick: () => (p.type === 'smb' || p.type === 'local' || p.type === 'dropbox' || p.type === 'onedrive' ? window.IPTV.openAddSource({ edit: id }) : app.views.main.router.navigate('/profile/' + id + '/')) },
                    { icon: p.shared ? 'link_off' : 'delete', label: t(p.shared ? 'share.leave' : 'settings.deleteProfile'), onClick: () => handlers.remove(id) }
                ]);
            },
            /** Con quién se comparte un proveedor: lista de personas (tocar una la quita) y «Añadir persona». */
            async shareProvider(id) {
                const p = profiles.get(id);
                if (!p || p.shared) return;
                let emails = [];
                try { emails = await account.profileShares(id); } catch (e) { notify.error(t('common.errorNetwork')); return; }
                const refresh = (list) => { profiles.save(profiles.list().map((x) => (x.id === id ? Object.assign({}, x, { sharedWith: list }) : x))); paint(); };
                const add = () => app.dialog.prompt(t('share.addHint'), t('share.add'), async (value) => {
                    const email = String(value || '').trim();
                    if (!email) return;
                    try {
                        const list = await account.shareProfile(id, email);
                        refresh(list);
                        notify.toast(t('share.added', { email }), { icon: 'group_add', duration: 3500 });
                    } catch (e) {
                        notify.error(t(e.code === 'self' ? 'share.errSelf' : e.code === 'invalid_email' ? 'share.errEmail' : 'common.errorNetwork'));
                    }
                }, null, '');
                const rows = emails.map((email) => ({ text: '✕  ' + email, onClick: () => notify.confirm(t('share.removeConfirm', { email }), t('share.remove'), async () => {
                    try { await account.unshareProfile(id, email); refresh(emails.filter((x) => x !== email)); } catch (e) { notify.error(t('common.errorNetwork')); }
                }) }));
                app.actions.create({ buttons: [
                    [{ text: t('share.title', { name: p.name || '' }), label: true }].concat(emails.length ? rows : [{ text: t('share.none'), label: true }]),
                    [{ text: '+  ' + t('share.add'), onClick: add }, { text: t('share.note'), label: true }],
                    [{ text: t('common.cancel'), color: 'red' }]
                ] }).open();
            },
            accessrequests() {
                openAccessRequests({ onChange: (n) => { accessPending = n; paint(); } });
            },
            /** Web con cuenta: canjear un código de invitación creado en una app de Android o Windows. */
            redeemweb() {
                app.dialog.prompt(t('share.redeemHint'), t('share.redeem'), async (value) => {
                    const code = String(value || '').trim();
                    if (!code) return;
                    try {
                        const prof = await inviteWeb.redeem(code, account.user ? account.user.name || account.user.email : '');
                        if (!profiles.current()) { profiles.setCurrent(prof.id); await actions.activateProfile(prof); } else { profiles.joinCatalog(prof.id); catalog.loadExtras({ force: true }).catch(() => {}); }
                        notify.toast(t('share.redeemed', { name: prof.name || t('share.sharedName'), who: prof.sharedBy || '' }), { icon: 'group', duration: 5000 });
                        paint();
                    } catch (e) {
                        notify.error(t(e && e.status === 404 ? 'share.badCode' : e && e.status === 429 ? 'share.tooMany' : 'common.errorNetwork'));
                    }
                }, null, '');
            },
            peekstyle() {
                app.actions.create({ buttons: [[{ text: t('settings.peekStyle'), label: true }, ...['row', 'float'].map((v) => ({ text: (((settings.get('peekStyle') || 'row') === v) ? '✓ ' : '') + t('settings.peekStyle.' + v), onClick: () => { settings.set('peekStyle', v); paint(); } })), ], [{ text: t('common.cancel'), color: 'red' }]] }).open();
            },
            tmdbmode() {
                app.actions.create({ buttons: [[{ text: t('settings.tmdbMode'), label: true }, ...['auto', 'basics', 'omdb', 'off'].map((v) => ({ text: (((settings.get('tmdbMode') || 'auto') === v) ? '✓ ' : '') + t('settings.tmdbMode.' + v), onClick: () => { settings.set('tmdbMode', v); if (window.IPTV.actions.applyTmdbMode) window.IPTV.actions.applyTmdbMode(); paint(); } }))], [{ text: t('common.cancel'), color: 'red' }]] }).open();
            },
            omdbweb() {
                settings.set('omdbOn', settings.get('omdbOn') === false);
                if (window.IPTV.actions.applyOmdb) window.IPTV.actions.applyOmdb();
                catalog._details.clear();
                paint();
            },
            async personal(id) {
                const p = profiles.get(id);
                if (!p) return;
                const on = !(p.personal && p.personal !== '0');
                await profiles.update(id, { personal: on ? '1' : '' });
                notify.toast(t(on ? 'settings.providerPersonalOn' : 'settings.providerPersonalOff'), { icon: 'video_library', duration: 3000 });
                // El catálogo guardado trae lo de antes (con o sin fichas): se rehace con el nuevo criterio.
                if (profiles.current() && profiles.current().id === id) catalog.refresh().catch(() => {});
                paint();
            },
            simulate() {
                app.actions.create({ buttons: [SIMULATE.map((o) => ({ text: t(o[1]), onClick: () => { catalog.simulate = o[0]; catalog.emit('change'); paint(); } })).concat([{ text: t('common.cancel'), color: 'red' }])] }).open();
            },
            lang() {
                const opts = [{ code: 'auto', name: t('common.auto') }].concat(i18n.available);
                app.actions.create({ buttons: [opts.map((o) => ({ text: o.name, onClick: () => actions.setLanguage(o.code) })).concat([{ text: t('common.cancel'), color: 'red' }])] }).open();
            },
            welcome() {
                app.views.main.router.navigate('/welcome/');
            },
            coachReset() {
                coach.reset();
                notify.toast(t('settings.coachResetDone'), { icon: 'tips_and_updates', duration: 2500 });
            },
            introPlay() {
                startIntro({ sound: settings.get('introSound') !== false });
            },
            tvmode() {
                const opts = [['auto', t('common.auto')], ['on', t('common.on')], ['off', t('common.off')]];
                app.actions.create({ buttons: [opts.map((o) => ({ text: o[1], onClick: () => { settings.set('tvMode', o[0]); actions.applyUiSettings(); paint(); } })).concat([{ text: t('common.cancel'), color: 'red' }])] }).open();
            },
            scale() {
                const opts = [0.85, 1, 1.15, 1.3];
                app.actions.create({ buttons: [opts.map((v) => ({ text: Math.round(v * 100) + '%', onClick: () => { settings.set('uiScale', v); actions.applyUiSettings(); paint(); } })).concat([{ text: t('common.cancel'), color: 'red' }])] }).open();
            },
            devices() {
                openDevices();
            },
            shell() {
                openShellPicker(() => { actions.applyUiSettings(); paint(); });
            },
            skin() {
                openSkinPicker(() => { actions.applyUiSettings(); paint(); });
            },
            theme() {
                const opts = [['dark', t('settings.themeDark')], ['light', t('settings.themeLight')], ['auto', t('settings.themeAuto')]];
                app.actions.create({ buttons: [opts.map((o) => ({ text: o[1], onClick: () => { settings.set('theme', o[0]); actions.applyUiSettings(); paint(); } })).concat([{ text: t('common.cancel'), color: 'red' }])] }).open();
            },
            subtitlelang() {
                app.actions.create({ buttons: [SUB_LANGS.map((o) => ({ text: o[1], onClick: () => { settings.set('subtitleLang', o[0]); paint(); } })).concat([{ text: t('common.cancel'), color: 'red' }])] }).open();
            },
            top10source() {
                const cur = settings.get('topSource') || 'own';
                const opts = [['own', t('settings.top10_own')], ['trending', t('settings.top10_trending')], ['off', t('settings.top10_off')]];
                app.actions.create({ buttons: [opts.map((o) => ({ text: (o[0] === cur ? '✓ ' : '') + o[1], onClick: () => { settings.set('topSource', o[0]); catalog.emit('change'); paint(); } })).concat([{ text: t('common.cancel'), color: 'red' }])] }).open();
            },
            navfade() {
                app.actions.create({ buttons: [[0, 25, 50, 75, 100].map((n) => ({ text: (navFadeValue(settings.all()) === n ? '✓ ' : '') + n + ' %', onClick: () => { settings.set('navFade', n); window.IPTV.actions.applyUiSettings(); paint(); } })).concat([{ text: t('common.cancel'), color: 'red' }])] }).open();
            },
            herointerval() {
                const cur = Number.isFinite(Number(settings.get('heroInterval'))) ? Number(settings.get('heroInterval')) : 8;
                const opts = [[0, t('settings.heroIntervalOff')], [5, t('settings.heroIntervalSec', { n: 5 })], [8, t('settings.heroIntervalSec', { n: 8 })], [12, t('settings.heroIntervalSec', { n: 12 })], [20, t('settings.heroIntervalSec', { n: 20 })]];
                app.actions.create({ buttons: [opts.map((o) => ({ text: (o[0] === cur ? '✓ ' : '') + o[1], onClick: () => { settings.set('heroInterval', o[0]); paint(); } })).concat([{ text: t('common.cancel'), color: 'red' }])] }).open();
            },
            factoryreset() {
                const text = t('settings.factoryResetConfirm') + (account.signedIn ? ' ' + t('settings.factoryResetAccount') : '');
                notify.confirm(text, t('settings.factoryReset'), async () => {
                    try { if (account.signedIn) await account.signOut(); } catch (e) { /* sin red: se sigue igual */ }
                    await factoryReset({ offline });
                });
            },
            uisounds() {
                const opts = [['auto', t('settings.uiSoundsAuto')], ['on', t('settings.uiSoundsOn')], ['off', t('settings.uiSoundsOff')]];
                const cur = settings.get('uiSounds') || 'auto';
                app.actions.create({ buttons: [opts.map((o) => ({ text: (o[0] === cur ? '✓ ' : '') + o[1], onClick: () => { settings.set('uiSounds', o[0]); paint(); if (o[0] !== 'off') playSound('select', { force: true }); } })).concat([{ text: t('common.cancel'), color: 'red' }])] }).open();
            },
            liveok() {
                const cur = settings.get('liveOkAction') === 'pause' ? 'pause' : 'channels';
                const opts = [['channels', t('settings.liveOkChannels')], ['pause', t('settings.liveOkPause')]];
                app.actions.create({ buttons: [opts.map((o) => ({ text: (o[0] === cur ? '✓ ' : '') + o[1], onClick: () => { settings.set('liveOkAction', o[0]); paint(); } })).concat([{ text: t('common.cancel'), color: 'red' }])] }).open();
            },
            liveview() {
                const opts = [['rows', t('live.viewRows')], ['grid', t('live.viewGrid')], ['list', t('live.viewList')], ['panel', t('live.viewPanel')]];
                const cur = settings.get('liveView') === 'stage' ? 'rows' : settings.get('liveView') || 'rows';
                app.actions.create({ buttons: [opts.map((o) => ({ text: (o[0] === cur ? '✓ ' : '') + o[1], onClick: () => { settings.set('liveView', o[0]); paint(); } })).concat([{ text: t('common.cancel'), color: 'red' }])] }).open();
            },
            channelliststyle() {
                const opts = [['panel', t('settings.channelListPanel')], ['strip', t('settings.channelListStrip')]];
                app.actions.create({ buttons: [opts.map((o) => ({ text: o[1], onClick: () => { settings.set('channelListStyle', o[0]); paint(); } })).concat([{ text: t('common.cancel'), color: 'red' }])] }).open();
            },
            liveinfostyle() {
                const opts = [['guide', t('settings.liveInfoGuide')], ['simple', t('settings.liveInfoSimple')]];
                app.actions.create({ buttons: [opts.map((o) => ({ text: o[1], onClick: () => { settings.set('liveInfoStyle', o[0]); paint(); } })).concat([{ text: t('common.cancel'), color: 'red' }])] }).open();
            },
            viewerauto() {
                const cur = Number.isFinite(Number(settings.get('viewerAutoPick'))) ? Number(settings.get('viewerAutoPick')) : 6;
                const opts = [[0, t('settings.viewerAutoOff')], [3, t('settings.heroIntervalSec', { n: 3 })], [6, t('settings.heroIntervalSec', { n: 6 })], [10, t('settings.heroIntervalSec', { n: 10 })], [15, t('settings.heroIntervalSec', { n: 15 })]];
                app.actions.create({ buttons: [opts.map((o) => ({ text: (o[0] === cur ? '✓ ' : '') + o[1], onClick: () => { settings.set('viewerAutoPick', o[0]); paint(); } })).concat([{ text: t('common.cancel'), color: 'red' }])] }).open();
            },
            episodeview() {
                const opts = [['auto', t('settings.viewAuto')], ['cards', t('settings.viewCards')], ['list', t('settings.viewList')]];
                app.actions.create({ buttons: [opts.map((o) => ({ text: o[1], onClick: () => { settings.set('episodeView', o[0]); paint(); } })).concat([{ text: t('common.cancel'), color: 'red' }])] }).open();
            },
            detailheader() {
                const opts = [['summary', t('settings.detailSummary')], ['full', t('settings.detailFull')]];
                app.actions.create({ buttons: [opts.map((o) => ({ text: o[1], onClick: () => { settings.set('detailHeader', o[0]); paint(); } })).concat([{ text: t('common.cancel'), color: 'red' }])] }).open();
            },
            livequality() {
                const opts = [['auto', t('settings.liveQualityAuto')], ['best', t('settings.liveQualityBest')], ['saver', t('settings.liveQualitySaver')]];
                app.actions.create({ buttons: [opts.map((o) => ({ text: o[1], onClick: () => { settings.set('liveQuality', o[0]); paint(); } })).concat([{ text: t('common.cancel'), color: 'red' }])] }).open();
            },
            transcode() {
                const opts = [['auto', t('common.auto')], ['always', t('settings.transcodeAlways')], ['never', t('settings.transcodeNever')]];
                app.actions.create({ buttons: [opts.map((o) => ({ text: o[1], onClick: () => { settings.set('transcodeAudio', o[0]); paint(); } })).concat([{ text: t('common.cancel'), color: 'red' }])] }).open();
            },
            nextoffer() {
                const cur = Number(settings.get('nextOfferSec'));
                const now = isFinite(cur) && cur >= 0 ? cur : 180;
                app.actions.create({ buttons: [
                    [{ text: t('settings.nextOffer'), label: true }].concat(NEXT_OFFER.map((sec) => ({ text: (sec === now ? '✓ ' : '') + nextOfferLabel(sec), onClick: () => { settings.set('nextOfferSec', sec); paint(); } }))),
                    [{ text: t('common.cancel'), color: 'red' }]
                ] }).open();
            },
            liveformat() {
                app.actions.create({ buttons: [[
                    { text: 'HLS (m3u8)', onClick: () => { settings.set('liveFormat', 'm3u8'); paint(); } },
                    { text: 'MPEG-TS (ts)', onClick: () => { settings.set('liveFormat', 'ts'); paint(); } },
                    { text: t('common.cancel'), color: 'red' }
                ]] }).open();
            },
            async parental() {
                const p = Object.assign({}, settings.get('parental'));
                if (!p.enabled) {
                    const pin = await actions.askNewPin();
                    if (!pin) return;
                    await catalog.setPin(pin);
                    p.enabled = true;
                    settings.set('parental', Object.assign({}, settings.get('parental'), { enabled: true }));
                    catalog.lock();
                } else {
                    if (!(await actions.askUnlock())) return;
                    settings.set('parental', Object.assign({}, p, { enabled: false }));
                    catalog.parentalUnlocked = false;
                    catalog.emit('change');
                }
                paint();
            },
            async pin() {
                if (!(await actions.askUnlock())) return;
                const pin = await actions.askNewPin();
                if (pin) {
                    await catalog.setPin(pin);
                    notify.toast(t('settings.updated'), { icon: 'check' });
                }
            },
            async parentalcats() {
                if (!(await actions.askUnlock())) return;
                openParentalCategories({ catalog, onSaved: paint });
            },
            async refresh() {
                notify.toast(t('settings.catalogUpdating'), { icon: 'sync' });
                await catalog.refresh();
                notify.toast(t('settings.catalogUpdated'), { icon: 'check' });
                paint();
            },
            async epg() {
                notify.toast(t('live.epgLoading'), { icon: 'sync' });
                try {
                    await catalog.loadEpg({ force: true });
                    notify.toast(t('live.epgUpdated'), { icon: 'check' });
                } catch (e) {
                    // Se dice la causa real (antes todo salía como «error de red»): un HTTP 404 no es lo mismo que no poder leer el fichero.
                    console.warn('[epg]', e);
                    const reason = e && e.status ? 'HTTP ' + e.status : e && e.code === 'gzip' ? t('settings.epgGzip') : e && e.message === 'timeout' ? t('settings.epgTimeout') : '';
                    notify.error(reason ? t('settings.epgFailed', { reason }) : t('common.errorNetwork'));
                }
                paint();
            },
            clear() {
                notify.confirm(t('settings.clearCacheSub'), t('settings.clearCache'), async () => {
                    await catalog.clearCache();
                    notify.toast(t('settings.cleared'), { icon: 'check' });
                    await catalog.refresh();
                    paint();
                });
            },
            proxy() {
                app.dialog.prompt(t('settings.proxySub'), t('settings.proxy'), (value) => {
                    settings.set('proxyUrl', (value || '').trim());
                    notify.toast(t('settings.updated'), { icon: 'check' });
                    paint();
                }, null, settings.get('proxyUrl') || '');
            },
            server() {
                app.dialog.prompt(t('settings.serverUrlSub'), t('settings.serverUrl'), (value) => {
                    settings.set('serverUrl', (value || '').trim());
                    location.reload();
                }, null, settings.get('serverUrl') || '');
            },
            users() {
                openUsersAdmin();
            },
            support() {
                openSupport({ onChange: paint });
            },
            report() {
                openReport();
            },
            credits() {
                openCredits();
            },
            paymentsAdmin() {
                openPaymentsAdmin();
            },
            licensesAdmin() {
                openLicensesAdmin();
            },
            reportsAdmin() {
                openReportsAdmin();
            },
            surveyAdmin() {
                openSurveyAdmin();
            },
            docsAdmin() {
                openDocsAdmin();
            },
            catalogStatus() {
                openCatalogStatus();
            },
            catalogReview() {
                openCatalogReview();
            },
            usageAdmin() {
                openUsageAdmin();
            },
            heroAdmin() {
                openHeroAdmin();
            },
            onlyLibraries() {
                catalog.setOnlyLibraries(!catalog.onlyLibraries);
                paint();
            },
            syncServers() {
                settings.set('syncServers', settings.get('syncServers') === false);
                paint();
            },
            // Modo desarrollador: 7 pulsaciones seguidas sobre la versión. Solo añade herramientas para quien administra la app.
            devTap() {
                const r = devMode.tap();
                if (r.unlocked) { notify.toast(t('dev.unlocked'), { icon: 'data_object', duration: 3500 }); paint(); } else if (!r.already && r.left > 0 && r.left <= 3) notify.toast(t('dev.left', { n: r.left }), { icon: 'data_object', duration: 1200 });
            },
            devOff() { devMode.set(false); notify.toast(t('dev.disabled'), { icon: 'check_circle', duration: 2500 }); paint(); },
            // Configuración completa en JSON (ajustes, filtros y orden): se ve, se copia, se descarga (web y Windows) o se comparte (Android).
            exportConfig() {
                const json = JSON.stringify(buildConfigExport({ appVersion: window.IPTV.version }), null, 2);
                const name = configFileName();
                const copy = async () => {
                    try { await navigator.clipboard.writeText(json); notify.toast(t('dev.copied'), { icon: 'content_copy', duration: 2500 }); } catch (e) { notify.error(t('dev.copyFailed')); }
                };
                const download = () => {
                    if (device.isCordova) { shareContent({ title: name, text: json }); return; }
                    const url = URL.createObjectURL(new Blob([json], { type: 'application/json' }));
                    const a = document.createElement('a');
                    a.href = url; a.download = name;
                    document.body.appendChild(a); a.click(); a.remove();
                    setTimeout(() => URL.revokeObjectURL(url), 4000);
                };
                window.app.dialog.create({
                    title: t('dev.exportConfig'),
                    text: `<p class="pw-note">${escapeHtml(t('dev.exportConfigNote', { name }))}</p><textarea readonly rows="10" style="width:100%;font-family:monospace;font-size:11px" data-dev-json>${escapeHtml(json)}</textarea>`,
                    buttons: [
                        { text: t('dev.copy'), onClick: copy, close: false },
                        { text: t(device.isCordova ? 'dev.share' : 'dev.download'), bold: true, onClick: download },
                        { text: t('common.close') }
                    ],
                    verticalButtons: true
                }).open();
            },
            update() {
                window.IPTV.updater.checkNow();
            },
            changepassword() {
                const has = !!(account.user && account.user.hasPassword);
                const field = (name, label, auto) => `<div class="field"><label>${escapeHtml(label)}</label><input name="${name}" type="password" autocomplete="${auto}" maxlength="128"/></div>`;
                const dialog = app.dialog.create({
                    title: t(has ? 'settings.changePassword' : 'settings.setPassword'),
                    content: `<form class="pw-dialog" novalidate>${has ? field('current', t('settings.currentPassword'), 'current-password') : ''}${field('password', t('settings.newPassword'), 'new-password')}${field('again', t('settings.repeatPassword'), 'new-password')}<div class="field-error" data-pw-error hidden></div></form>`,
                    closeByBackdropClick: false,
                    buttons: [
                        { text: t('common.cancel') },
                        {
                            text: t('common.save'),
                            bold: true,
                            close: false,
                            onClick: async (d) => {
                                const form = d.$el[0].querySelector('form');
                                const err = form.querySelector('[data-pw-error]');
                                const fail = (msg) => { err.textContent = msg; err.hidden = false; };
                                if (form.password.value !== form.again.value) return fail(t('settings.passwordMismatch'));
                                try {
                                    await account.changePassword({ current: has ? form.current.value : '', password: form.password.value });
                                    d.close();
                                    notify.toast(t('settings.passwordChanged'), { icon: 'check_circle', duration: 4000 });
                                    paint();
                                } catch (e) {
                                    const key = 'login.pw.error.' + (e && e.code);
                                    const msg = e && e.code ? t(key) : '';
                                    fail(msg && msg !== key ? msg : t('common.errorNetwork'));
                                }
                            }
                        }
                    ]
                });
                addPasswordToggles(dialog.$el[0]);
                dialog.open();
            },
            deleteaccount() {
                notify.confirm(t('settings.deleteAccountConfirm', { email: account.user.email }), t('settings.deleteAccount'), async () => {
                    try {
                        await account.deleteAccount();
                    } catch (e) {
                        notify.error(e && e.code === 'last_admin' ? t('settings.deleteAccountLastAdmin') : t('common.errorNetwork'));
                        return;
                    }
                    await catalog.clearCache().catch(() => {});
                    await actions.signOut();
                    notify.toast(t('settings.deleteAccountDone'), { icon: 'check_circle', duration: 4000 });
                });
            },
            signout() {
                if (account.demo) return; // la demo no se abandona a mano
                notify.confirm(t('settings.signOutConfirm'), t('settings.signOutGoogle'), () => actions.signOut());
            },
            logout() {
                notify.confirm(t('settings.logout') + '?', t('settings.logout'), async () => {
                    const p = profiles.current();
                    if (p) {
                        await catalog.purgeProfile(p.id);
                        await profiles.remove(p.id);
                    }
                    const next = profiles.current();
                    if (next) {
                        await actions.activateProfile(next);
                        paint();
                    } else {
                        await catalog.use(null);
                        app.views.main.router.navigate(firstScreen({ needsAccount: account.enabled && !account.signedIn }), { reloadAll: true, clearPreviousHistory: true });
                    }
                });
            }
        };

        /** Clics de una fila de la lista de fuentes (en la ventana «Fuentes»). Devuelve true si lo atendió. */
        const handleRowClick = (e) => {
            const moreInfo = e.target.closest('[data-src-more]');
            if (moreInfo) {
                // Despliega o pliega las cifras de esa fila sin repintar la lista ni abrir la pantalla de la fuente.
                const id = moreInfo.getAttribute('data-src-more');
                const row = moreInfo.closest('.src-row');
                const on = !srcOpen.has(id);
                if (on) srcOpen.add(id); else srcOpen.delete(id);
                if (row) row.classList.toggle('is-open', on);
                moreInfo.setAttribute('aria-expanded', String(on));
                moreInfo.querySelector('.src-toggle-text').textContent = t(on ? 'src.less' : 'src.more');
                return true;
            }
            const retry = e.target.closest('[data-src-retry]');
            if (retry) { handlers.refreshSource(retry.getAttribute('data-src-retry')); return true; }
            const tog = e.target.closest('[data-provider-toggle]');
            if (tog) { handlers.toggle(tog.getAttribute('data-provider-toggle')); return true; }
            const more = e.target.closest('[data-provider-more]');
            if (more) { handlers.more(more.getAttribute('data-provider-more'), more); return true; }
            const open = e.target.closest('[data-src-open]');
            if (open) { openSourceDetail(open.getAttribute('data-src-open')); return true; }
            return false;
        };

        body.addEventListener('click', (e) => {
            // En la pestaña solo hay cifras y botones: tocar una caja de resumen o «Ver fuentes» abre la ventana con la lista.
            const flt = e.target.closest('[data-src-filter]');
            if (flt) return openSourcesModal(flt.getAttribute('data-src-filter'));
            if (e.target.closest('[data-src-view]')) return openSourcesModal('all');
            const btn = e.target.closest('[data-setting]');
            if (!btn) return;
            const action = btn.getAttribute('data-setting');
            if (action === 'spotify') { toggleSpotifyLink().then((changed) => { if (changed && body.isConnected) paint(); }); return; }
            if (action.indexOf('toggle:') === 0) {
                const key = action.slice(7);
                settings.set(key, !settings.get(key));
                if (key === 'fireLayout') { tvOpen = false; actions.applyUiSettings(); } // cambia la forma de toda la pantalla de Ajustes
                paint();
                return;
            }
            if (handlers[action]) handlers[action]();
        });

        paint();
        // Spotify Connect: si el servidor lo tiene configurado aparece su fila (se sabe tras preguntarlo una vez).
        if (!spotify.configuredSync()) spotify.configured().then((on) => { if (on && body.isConnected) paint(); });
        // Se enseña lo último que se sabe de cada proveedor y, a la vez, se pregunta a sus paneles.
        providers.load().then(() => { paint(); return providers.checkAll(profiles.list()); }).then(() => catalog.checkSubscriptionSoon()).catch(() => {});
        const repaint = debounce(paint, 300);
        const off = [catalog.on('change', repaint), catalog.on('sources', repaint), providers.on('change', repaint)];
        return () => { off.forEach((fn) => fn()); if (window.IPTV && window.IPTV.settingsBack === tvBack) window.IPTV.settingsBack = null; };
    }
};
